import { Injectable } from '@angular/core';
import { WindowRefService } from '../window-ref/window-ref.service';

@Injectable()
export class EnvironmentService {

  public adalConfig: any;

  private _env: string;
  private _windowRef: WindowRefService;

  constructor(windowRef: WindowRefService) {
    this._windowRef = windowRef;

    let environment = document.head
      .querySelector('meta[name=environment]')
      .getAttribute('content');

    if (environment.startsWith("#") && this.isLocalhost()) {
      environment = "development";
    }
  
    this.init(environment);
  }

  private init(environmentName: string) {
    this._env = environmentName;

    const root: string = `${window.location.origin}/`;
    this.adalConfig = {
      clientId: '980518bf-c438-4eed-a46a-871f2d249dec',
      //redirectUri: root, 
      //replyUri: `${window.location.origin}`,
      vstsResourceId: '499b84ac-1321-427f-aa17-267ca6975798',
      popUp: true,
      cacheLocation: 'localStorage',
      //localLoginUrl: `${window.location.origin}/#/login`,
      //postLogoutRedirectUri: root,
      callback: this.loginOccurred
    }

  }

  loginOccurred(errorDesc, token, error, tokenType) {
    console.log(`error desc ... ${errorDesc}`);
    console.log(`token ........ ${token}`);
    console.log(`error ........ ${error}`);
    console.log(`token type ... ${tokenType}`);
    document.location.reload();
  }

  getEnvironmentName() {
    return this._env;
  }

  /**
   * Gets the root of the api url - ending with api/
   */
  getApiRoot() {
    if (this.isLocalhost()) {
      return "http://localhost/Monitoring/api/";
    }
    else {
      return "api/";
    }
  }


  /**
   * Returns whether the site is running on localhost.
   */
  private isLocalhost(): boolean {
    //return this._windowRef.nativeWindow.location.href.search("localhost") > -1;
    return this._windowRef.getHref().search("localhost") > -1;
  }

}
